import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import App from '../App';
import Dashboard from '../pages/Dashboard';
import ShopFloor from '../pages/ShopFloor';
import Login from '../pages/Login';
import CRM from '../pages/CRM';
import ClientDetail from '../pages/ClientDetail';
import ClientForm from '../pages/ClientForm';
import Licitacions from '../pages/Licitacions';
import LicitacioForm from '../pages/LicitacioForm';
import TenderCriteriaConfig from '../pages/crm/TenderCriteriaConfig';
import TenderExclusionStats from '../pages/crm/TenderExclusionStats';
import BudgetList from '../pages/crm/BudgetList';
import BudgetForm from '../pages/crm/BudgetForm';
import SalesOrderForm from '../pages/crm/SalesOrderForm';
import ExpedientComercialList from '../pages/crm/ExpedientComercialList';
import ExpedientComercialForm from '../pages/crm/ExpedientComercialForm';
import Compras from '../pages/Compras';
import SupplierForm from '../pages/compras/SupplierForm';
import MaterialForm from '../pages/compras/MaterialForm';
import Nodes from '../pages/compras/Nodes';
import NodeForm from '../pages/compras/NodeForm';
import CreatePurchaseOrder from '../pages/compras/CreatePurchaseOrder';
import PurchaseOrderDetail from '../pages/compras/PurchaseOrderDetail';
import Taller from '../pages/Taller';
import ExpedientDetailPage from '../pages/taller/ExpedientDetailPage';
import PlanificacioGeneral from '../pages/PlanificacioGeneral';
import RRHH from '../pages/RRHH';
import EmployeeDetail from '../pages/EmployeeDetail';
import WorkLogs from '../pages/rrhh/WorkLogs';
import Absences from '../pages/rrhh/Absences';
import Trainings from '../pages/rrhh/Trainings';
import Payroll from '../pages/rrhh/Payroll';
import Evaluations from '../pages/rrhh/Evaluations';
import Holidays from '../pages/rrhh/Holidays';
import LaborCalendar from '../pages/rrhh/LaborCalendar';
import Documents from '../pages/rrhh/Documents';
import DocumentsPage from '../pages/documents/DocumentsPage';
import Comptabilitat from '../pages/Comptabilitat';
import ComptabilitatLayout from '../pages/comptabilitat/ComptabilitatLayout';
import Facturacio from '../pages/Facturacio';
import { ProtectedRoute } from '../auth/ProtectedRoute';
import { ProtectedCompanyRoute } from '../company/ProtectedCompanyRoute';
// Admin imports
import AdminLayout from '../layouts/AdminLayout';
import AdminDashboard from '../pages/admin/Dashboard';
import AdminUsers from '../pages/admin/users/Users';
import AdminUserForm from '../pages/admin/users/UserForm';
import AdminCompanies from '../pages/admin/companies/Companies';
import AdminBrands from '../pages/admin/brands/Brands';
import AdminSettings from '../pages/admin/settings/Settings';
import AdminCounters from '../pages/admin/counters/Counters';
import AdminTypes from '../pages/admin/types/AdminTypes';

// Route definitions
const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />,
  },
  // Protected routes
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <PlanificacioGeneral />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'terminal',
        element: <ShopFloor />,
      },
      // Module routes
      {
        path: 'compres',
        element: <Compras />,
      },
      {
        path: 'compres/comandes/new',
        element: <CreatePurchaseOrder />,
      },
      {
        path: 'compres/comandes/:id/edit',
        element: <CreatePurchaseOrder />,
      },
      {
        path: 'compres/comandes/:id',
        element: <PurchaseOrderDetail />,
      },
      {
        path: 'compres/proveidors/:id',
        element: <SupplierForm />,
      },
      {
        path: 'compres/proveidors/new',
        element: <SupplierForm />,
      },
      {
        path: 'compres/materials/new',
        element: <MaterialForm />,
      },
      {
        path: 'compres/materials/:id/edit',
        element: <MaterialForm />,
      },
      {
        path: 'compres/nodes',
        element: <Nodes />,
      },
      {
        path: 'compres/nodes/new',
        element: <NodeForm />,
      },
      {
        path: 'compres/nodes/:id/edit',
        element: <NodeForm />,
      },
      {
        path: 'crm',
        element: <CRM />,
      },
      {
        path: 'crm/clients/:id',
        element: <ClientDetail />,
      },
      {
        path: 'crm/clients/:id/edit',
        element: <ClientForm />,
      },
      {
        path: 'crm/clients/new',
        element: <ClientForm />,
      },
      {
        path: 'crm/licitacions',
        element: <Licitacions />,
      },
      {
        path: 'crm/licitacions/new',
        element: <LicitacioForm />,
      },
      {
        path: 'crm/licitacions/criteris',
        element: <TenderCriteriaConfig />,
      },
      {
        path: 'crm/licitacions/estadistiques-eliminacio',
        element: <TenderExclusionStats />,
      },
      {
        path: 'crm/licitacions/:id/edit',
        element: <LicitacioForm />,
      },
      {
        path: 'crm/pressupostos',
        element: <BudgetList />,
      },
      {
        path: 'crm/pressupostos/new',
        element: <BudgetForm />,
      },
      {
        path: 'crm/pressupostos/:id/edit',
        element: <BudgetForm />,
      },
      {
        path: 'crm/comandes/new',
        element: <SalesOrderForm />,
      },
      {
        path: 'crm/comandes/:id/edit',
        element: <SalesOrderForm />,
      },
      {
        path: 'crm/expedients-comercials',
        element: <ExpedientComercialList />,
      },
      {
        path: 'crm/expedients-comercials/new',
        element: <ExpedientComercialForm />,
      },
      {
        path: 'crm/expedients-comercials/:id/edit',
        element: <ExpedientComercialForm />,
      },
      {
        path: 'taller',
        element: <Taller />,
      },
      {
        path: 'planificacio-general',
        element: <PlanificacioGeneral />,
      },
      {
        path: 'taller/expedients/new',
        element: <ExpedientDetailPage />,
      },
      {
        path: 'taller/expedients/:id',
        element: <ExpedientDetailPage />,
      },
      {
        path: 'rrhh',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><RRHH /></ProtectedRoute>,
      },
      {
        path: 'rrhh/empleats/new',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><EmployeeDetail /></ProtectedRoute>,
      },
      {
        path: 'rrhh/empleats/:id/edit',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><EmployeeDetail /></ProtectedRoute>,
      },
      {
        path: 'rrhh/empleats/:id',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><EmployeeDetail /></ProtectedRoute>,
      },
      {
        path: 'rrhh/employees/new',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><EmployeeDetail /></ProtectedRoute>,
      },
      {
        path: 'rrhh/employees/:id/edit',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><EmployeeDetail /></ProtectedRoute>,
      },
      {
        path: 'rrhh/employees/:id',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><EmployeeDetail /></ProtectedRoute>,
      },
      {
        path: 'rrhh/work-logs',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><WorkLogs /></ProtectedRoute>,
      },
      {
        path: 'rrhh/absences',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Absences /></ProtectedRoute>,
      },
      {
        path: 'rrhh/trainings',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Trainings /></ProtectedRoute>,
      },
      {
        path: 'rrhh/payroll',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Payroll /></ProtectedRoute>,
      },
      {
        path: 'rrhh/evaluations',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Evaluations /></ProtectedRoute>,
      },
      {
        path: 'rrhh/holidays',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Holidays /></ProtectedRoute>,
      },
      {
        path: 'rrhh/calendar',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><LaborCalendar /></ProtectedRoute>,
      },
      {
        path: 'rrhh/documents',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Documents /></ProtectedRoute>,
      },
      {
        path: 'comptabilitat',
        element: (
          <ProtectedRoute allowedRoles={['ADMIN']}>
            <ProtectedCompanyRoute>
              <Comptabilitat />
            </ProtectedCompanyRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'comptabilitat/:section',
        element: (
          <ProtectedRoute allowedRoles={['ADMIN']}>
            <ProtectedCompanyRoute>
              <ComptabilitatLayout />
            </ProtectedCompanyRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'facturacio',
        element: (
          <ProtectedRoute allowedRoles={['ADMIN']}>
            <ProtectedCompanyRoute>
              <Facturacio />
            </ProtectedCompanyRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'documents/*',
        element: <ProtectedRoute allowedRoles={['ADMIN']}><DocumentsPage /></ProtectedRoute>,
      },
      // Admin (integrado en el mismo shell que el resto de módulos)
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          {
            index: true,
            element: <AdminDashboard />,
          },
          {
            path: 'users',
            element: <AdminUsers />,
          },
          {
            path: 'users/new',
            element: <AdminUserForm />,
          },
          {
            path: 'users/:id/edit',
            element: <AdminUserForm />,
          },
          {
            path: 'companies',
            element: <AdminCompanies />,
          },
          {
            path: 'brands',
            element: <AdminBrands />,
          },
          {
            path: 'settings',
            element: <AdminSettings />,
          },
          {
            path: 'counters',
            element: <AdminCounters />,
          },
          {
            path: 'types',
            element: <AdminTypes />,
          },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
